module.exports = __webpack_public_path__ + "static/img/buildnew.f7a92c58.png";